import React from "react";
import { Tab, Nav } from "react-bootstrap";
import { TabsVersiones } from "../../Components/TabsVersiones/TabsVersiones";

export class TabsTablas extends React.Component {
  render() {
    const { tablas } = this.props;

    return (
      <Tab.Container id="tabs-tablas" defaultActiveKey={tablas[0]?.codigoTabla}>
        <Nav variant="tabs">
          {tablas.map((tabla, index) => (
            <Nav.Item key={index}>
              <Nav.Link eventKey={tabla.codigoTabla}>{tabla.codigoTabla}</Nav.Link>
            </Nav.Item>
          ))}
        </Nav>
        <Tab.Content>
          {tablas.map((tabla, index) => (
            <Tab.Pane key={index} eventKey={tabla.codigoTabla}>
              <TabsVersiones versiones={tabla.versiones} />
            </Tab.Pane>
          ))}
        </Tab.Content>
      </Tab.Container>
    );
  }
}
